// components/ConfirmActionModal.tsx
import { Modal, Group, Text, Button } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

interface ConfirmActionModalProps {
  opened: boolean;
  title: string;
  message: string;
  color?: 'red' | 'orange';
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export default function ConfirmActionModal({
  opened, title, message, color = 'red', onConfirm, onClose,
}: ConfirmActionModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="xs">
          <IconTrash size={18} color="red" />
          <Text fw={600}>{title}</Text>
        </Group>
      }
      centered
      size="sm"
    >
      <Text size="sm" mb="lg">{message}</Text>
      <Group justify="flex-end" gap="sm">
        <Button variant="subtle" onClick={onClose}>Cancel</Button>
        <Button color={color} onClick={async () => { await onConfirm(); onClose(); }}>
          Confirm
        </Button>
      </Group>
    </Modal>
  );
}